import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getDenominationHierarchy = ({
  denominationId,
  page,
  pageSize,
  parentId,
  structureTypeId
}) => {
  const params = new URLSearchParams();

  if (page && pageSize) {
    params.append("page", page);
    params.append("per_page", pageSize);
  }

  if (parentId) {
    params.append("parent_id", parentId);
  }

  if (structureTypeId) {
    params.append("structure_type_id", structureTypeId);
  }

  const queryString = params.toString();
  const url = `/denominations/${denominationId}/hierarchy${
    queryString ? `?${queryString}` : ""
  }`;

  return axios.get(url);
};

export const useDenominationHierarchy = ({
  config,
  denominationId,
  page,
  pageSize,
  parentId,
  structureTypeId
} = {}) => {
  return useQuery({
    ...config,
    queryKey: [
      "denominations-hierarchy",
      denominationId,
      page,
      pageSize,
      parentId,
      structureTypeId
    ],
    queryFn: () =>
      getDenominationHierarchy({
        denominationId,
        page,
        pageSize,
        parentId,
        structureTypeId
      })
  });
};
